import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Open+Sans:wght@400;600&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  body { font-family: 'Open Sans', sans-serif; color: #333; }

  .sb-nav {
    position: sticky;
    top: 0;
    z-index: 100;
    padding: 16px 22px;
    background: rgba(251, 248, 239, 0.9);
    backdrop-filter: blur(18px);
    border-bottom: 1px solid rgba(26, 46, 110, 0.08);
  }
  .sb-nav-inner {
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 22px;
    padding: 14px 20px;
    background: rgba(255,255,255,0.72);
    border: 1px solid rgba(26, 46, 110, 0.08);
    border-radius: 22px;
    box-shadow: 0 14px 38px rgba(29, 41, 81, 0.08);
  }
  .sb-logo {
    display: flex;
    align-items: center;
    gap: 14px;
    text-decoration: none;
  }
  .sb-logo-img {
    height: 56px;
    width: auto;
    display: block;
    flex-shrink: 0;
  }
  .sb-logo-copy {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .sb-logo-title {
    font-family: 'Nunito', sans-serif;
    font-size: 26px;
    font-weight: 900;
    color: #1a2e6e;
    line-height: 1;
    letter-spacing: -0.8px;
  }
  .sb-logo-subtitle {
    color: #6a738c;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
  }
  .sb-nav-meta {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .sb-nav-contact {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
    padding: 10px 14px;
    border-radius: 16px;
    background: rgba(245, 166, 35, 0.1);
    border: 1px solid rgba(245, 166, 35, 0.16);
  }
  .sb-nav-contact span {
    color: #7f6b3e;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
  .sb-nav-contact strong {
    color: #1a2e6e;
    font-family: 'Nunito', sans-serif;
    font-size: 15px;
    font-weight: 900;
  }

  .sb-footer-logo-img {
    height: 48px;
    width: auto;
    display: block;
  }
  
  .sb-footer-right {
    display: flex;
    align-items: center;
    gap: 24px;
  }

  .sb-footer-socials {
    display: flex;
    gap: 16px;
  }

  .sb-footer-socials a {
    color: #fff;
    text-decoration: none;
    font-weight: 600;
    transition: opacity .2s;
  }

  .sb-footer-socials a:hover {
    opacity: .8;
  }

  @media (max-width: 620px) {
    .sb-footer-right {
      flex-direction: column;
      gap: 14px;
    }

    .sb-footer-socials {
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  .sb-nav-btns {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .btn-label { display: inline; }
  .btn-whatsapp,
  .btn-call {
    border: none;
    padding: 12px 20px;
    border-radius: 14px;
    font-weight: 800;
    font-size: 14px;
    cursor: pointer;
    font-family: 'Nunito', sans-serif;
    transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s, background 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 12px 26px rgba(29, 41, 81, 0.08);
  }
  .btn-whatsapp {
    background: #25D366;
    color: #fff;
  }
  .btn-call {
    background: #fff;
    color: #1a2e6e;
    border: 1px solid rgba(26, 46, 110, 0.14);
  }
  .btn-whatsapp:hover,
  .btn-call:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 32px rgba(29, 41, 81, 0.12);
  }
  .btn-whatsapp:hover { opacity: 0.95; }
  .btn-call:hover { background: #f7f9ff; }

  @media (max-width: 900px) {
    .sb-nav {
      padding: 14px 16px;
    }
    .sb-nav-inner {
      padding: 14px 16px;
    }
    .sb-logo-title {
      font-size: 22px;
    }
    .sb-logo-subtitle {
      font-size: 12px;
    }
    .sb-nav-contact {
      display: none;
    }
    .btn-whatsapp,
    .btn-call {
      padding: 11px 16px;
    }
  }

  @media (max-width: 620px) {
    .sb-nav-inner {
      padding: 12px;
      border-radius: 18px;
    }
    .sb-logo {
      gap: 10px;
    }
    .sb-logo-img {
      height: 46px;
    }
    .sb-logo-title {
      font-size: 18px;
      letter-spacing: -0.4px;
    }
    .sb-logo-subtitle {
      display: none;
    }
    .sb-nav-meta {
      gap: 8px;
    }
    .btn-whatsapp,
    .btn-call {
      padding: 10px 12px;
      font-size: 17px;
      border-radius: 12px;
      gap: 0;
    }
    .btn-label { display: none; }
  }

  @media (max-width: 480px) {
    .sb-nav {
      padding: 10px 12px;
    }
    .sb-nav-inner {
      gap: 10px;
      padding: 10px;
    }
    .sb-logo-title {
      font-size: 17px;
    }
  }

  /* Hero */
  .sb-hero {
    position: relative;
    min-height: 680px;
    padding: 84px 40px 92px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background:
      radial-gradient(circle at top left, rgba(245, 166, 35, 0.16), transparent 28%),
      radial-gradient(circle at bottom right, rgba(26, 46, 110, 0.08), transparent 32%),
      #fbf8ef;
  }
  .sb-hero-bg {
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(rgba(235, 208, 146, 0.18) 1px, transparent 1px),
      linear-gradient(90deg, rgba(235, 208, 146, 0.18) 1px, transparent 1px);
    background-size: 46px 46px;
    opacity: 0.95;
  }
  .sb-hero-shell {
    position: relative;
    z-index: 1;
    width: min(1120px, 100%);
    text-align: center;
  }
  .sb-hero-logo-wrap {
    width: fit-content;
    margin: 0 auto 10px;
  }
  .sb-hero-logo {
    height: 170px;
    width: auto;
    display: block;
  }
  .sb-hero-kicker {
    font-family: 'Nunito', sans-serif;
    font-size: 28px;
    font-weight: 700;
    color: #304180;
    line-height: 1.2;
    margin-bottom: 10px;
  }
  .sb-hero-title {
    font-family: 'Nunito', sans-serif;
    font-size: clamp(52px, 8vw, 88px);
    font-weight: 900;
    color: #1a2e6e;
    line-height: 0.95;
    letter-spacing: -2px;
    max-width: 900px;
    margin: 0 auto 18px;
  }
  .sb-hero-title span {
    display: block;
    font-size: clamp(24px, 3vw, 42px);
    letter-spacing: 0;
    margin-top: 10px;
  }
  .sb-hero-copy {
    max-width: 760px;
    margin: 0 auto 28px;
    color: #5c6480;
    font-size: 18px;
    line-height: 1.6;
  }
  .sb-hero-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    flex-wrap: wrap;
    margin-bottom: 28px;
  }
  .sb-btn-secondary {
    background: rgba(255,255,255,0.7);
    color: #1a2e6e;
    border: 1px solid rgba(26, 46, 110, 0.14);
    padding: 16px 28px;
    border-radius: 50px;
    font-weight: 800;
    font-size: 16px;
    cursor: pointer;
    font-family: 'Nunito', sans-serif;
    transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
    box-shadow: 0 12px 28px rgba(29, 41, 81, 0.08);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .sb-btn-secondary:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 36px rgba(29, 41, 81, 0.12);
    background: #fff;
  }
  .sb-hero-points {
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  .sb-hero-point {
    padding: 10px 18px;
    border-radius: 999px;
    background: rgba(255,255,255,0.72);
    border: 1px solid rgba(26, 46, 110, 0.08);
    color: #31416e;
    font-size: 14px;
    font-weight: 700;
    box-shadow: 0 10px 24px rgba(29, 41, 81, 0.07);
  }
  .sb-hero-float {
    position: absolute;
    z-index: 1;
    padding: 16px 18px;
    border-radius: 20px;
    background: rgba(255,255,255,0.86);
    border: 1px solid rgba(26, 46, 110, 0.08);
    box-shadow: 0 20px 44px rgba(29, 41, 81, 0.1);
    text-align: left;
    backdrop-filter: blur(10px);
  }
  .sb-hero-float strong {
    display: block;
    font-family: 'Nunito', sans-serif;
    color: #1a2e6e;
    font-size: 15px;
    margin-bottom: 4px;
  }
  .sb-hero-float span {
    color: #717a95;
    font-size: 13px;
  }
  .sb-hero-float-left {
    top: 145px;
    left: max(32px, calc(50% - 520px));
    transform: rotate(-9deg);
  }
  .sb-hero-float-right {
    right: max(32px, calc(50% - 500px));
    bottom: 110px;
    transform: rotate(10deg);
  }
  .btn-orange {
    background: #F5A623;
    color: #fff;
    border: none;
    padding: 16px 40px;
    border-radius: 50px;
    font-weight: 800;
    font-size: 17px;
    cursor: pointer;
    font-family: 'Nunito', sans-serif;
    transition: transform 0.2s, box-shadow 0.2s;
    box-shadow: 0 4px 20px rgba(245,166,35,0.4);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .btn-orange:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(245,166,35,0.5); }

  @media (max-width: 900px) {
    .sb-hero {
      min-height: 620px;
      padding: 70px 20px 82px;
    }
    .sb-hero-logo {
      height: 140px;
    }
    .sb-hero-kicker {
      font-size: 24px;
    }
    .sb-hero-copy {
      font-size: 17px;
    }
    .sb-hero-float {
      display: none;
    }
  }

  @media (max-width: 560px) {
    .sb-hero {
      min-height: auto;
      padding: 58px 16px 70px;
    }
    .sb-hero-logo-wrap {
      margin-bottom: 8px;
    }
    .sb-hero-logo {
      height: 104px;
    }
    .sb-hero-kicker {
      font-size: 21px;
    }
    .sb-hero-title {
      letter-spacing: -1px;
      line-height: 1;
      margin-bottom: 14px;
    }
    .sb-hero-title span {
      margin-top: 8px;
    }
    .sb-hero-copy {
      font-size: 15px;
      margin-bottom: 22px;
    }
    .sb-hero-actions {
      gap: 10px;
      margin-bottom: 22px;
    }
    .btn-orange, .sb-btn-secondary {
      width: 100%;
      justify-content: center;
    }
    .sb-hero-point {
      font-size: 13px;
      padding: 9px 14px;
    }
  }

  /* Shared lower sections */
  .sb-section {
    position: relative;
    padding: 76px 40px;
  }
  .sb-section-inner {
    width: min(1120px, 100%);
    margin: 0 auto;
  }
  .sb-section-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 28px;
    margin-bottom: 30px;
  }
  .sb-section-head-center {
    display: block;
    text-align: center;
    max-width: 740px;
    margin: 0 auto 34px;
  }
  .sb-section-eyebrow {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    margin-bottom: 10px;
    padding: 6px 11px;
    border-radius: 999px;
    background: rgba(245, 166, 35, 0.1);
    color: #8b6418;
    font-family: 'Nunito', sans-serif;
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 0.07em;
    text-transform: uppercase;
  }
  .sb-section-head-center .sb-section-eyebrow {
    margin-left: auto;
    margin-right: auto;
  }
  .sb-section-title {
    font-family: 'Nunito', sans-serif;
    font-size: clamp(29px, 3.3vw, 40px);
    font-weight: 900;
    color: #1a2e6e;
    line-height: 1.12;
    margin-bottom: 10px;
  }
  .sb-section-lead {
    color: #66708d;
    font-size: 15px;
    line-height: 1.68;
    max-width: 640px;
  }
  .sb-section-head-center .sb-section-lead {
    margin: 0 auto;
  }
  .sb-section-action {
    flex-shrink: 0;
  }

  /* Why Choose Us */
  .sb-why {
    overflow: hidden;
    background:
      linear-gradient(rgba(235, 208, 146, 0.14) 1px, transparent 1px),
      linear-gradient(90deg, rgba(235, 208, 146, 0.14) 1px, transparent 1px),
      #fbf8ef;
    background-size: 44px 44px;
  }
  .sb-cards-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
  .sb-card {
    position: relative;
    min-height: 188px;
    background: rgba(255,255,255,0.84);
    border: 1px solid rgba(26, 46, 110, 0.09);
    border-radius: 8px;
    padding: 24px 22px;
    box-shadow: 0 14px 30px rgba(29, 41, 81, 0.06);
    transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
  }
  .sb-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: rgba(245, 166, 35, 0.72);
  }
  .sb-card:hover {
    transform: translateY(-3px);
    border-color: rgba(26, 46, 110, 0.16);
    box-shadow: 0 18px 36px rgba(29, 41, 81, 0.09);
  }
  .sb-card-icon {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 18px;
    border-radius: 8px;
    background: rgba(26, 46, 110, 0.06);
    font-size: 23px;
  }
  .sb-card h3 {
    font-family: 'Nunito', sans-serif;
    font-size: 16px;
    font-weight: 900;
    color: #1a2e6e;
    margin-bottom: 8px;
  }
  .sb-card p {
    color: #66708d;
    font-size: 14px;
    line-height: 1.62;
  }
  .sb-proof-strip {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin-top: 18px;
    overflow: hidden;
  }
  .sb-proof-item {
    padding: 18px 20px;
    border: 1px solid rgba(26, 46, 110, 0.08);
    border-radius: 8px;
    background: rgba(255,255,255,0.58);
  }
  .sb-proof-item strong {
    display: block;
    font-family: 'Nunito', sans-serif;
    color: #1a2e6e;
    font-size: 24px;
    font-weight: 900;
    line-height: 1;
    margin-bottom: 6px;
  }
  .sb-proof-item span {
    color: #6a738c;
    font-size: 13px;
    font-weight: 600;
  }

  /* Destinations */
  .sb-destinations {
    background: #fff;
    scroll-margin-top: 112px;
  }
  .sb-dest-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
  }
  .sb-dest-item {
    width: 100%;
    position: relative;
    min-height: 256px;
    border: 1px solid rgba(26, 46, 110, 0.09);
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    background: #fff;
    box-shadow: 0 10px 26px rgba(29, 41, 81, 0.06);
    color: inherit;
    font: inherit;
    text-align: left;
    appearance: none;
  }
  .sb-dest-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 16px 34px rgba(29, 41, 81, 0.1);
  }
  .sb-dest-img {
    width: 100%;
    height: 142px;
    object-fit: cover;
    display: block;
  }
  .sb-dest-body {
    padding: 16px;
  }
  .sb-dest-item h3 {
    font-family: 'Nunito', sans-serif;
    font-size: 19px;
    font-weight: 900;
    color: #1a2e6e;
    margin-bottom: 7px;
  }
  .sb-dest-item p {
    color: #69738d;
    font-size: 13px;
    line-height: 1.55;
    margin-bottom: 12px;
  }
  .sb-dest-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    color: #986a12;
    font-family: 'Nunito', sans-serif;
    font-size: 13px;
    font-weight: 800;
  }
  .sb-dest-arrow {
    width: 26px;
    height: 26px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    color: #1a2e6e;
    background: #fbf8ef;
  }

  /* Services */
  .sb-services {
    background: #f7f9ff;
  }
  .sb-services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }
  .sb-service-card {
    position: relative;
    background: rgba(255,255,255,0.9);
    border: 1px solid rgba(26, 46, 110, 0.1);
    border-radius: 8px;
    padding: 26px 24px;
    box-shadow: 0 12px 28px rgba(29, 41, 81, 0.06);
  }
  .sb-service-step {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 38px;
    height: 26px;
    margin-bottom: 20px;
    border-radius: 999px;
    background: rgba(26, 46, 110, 0.08);
    color: #1a2e6e;
    font-family: 'Nunito', sans-serif;
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0.06em;
  }
  .sb-service-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    border-radius: 8px;
    background: rgba(245, 166, 35, 0.12);
    font-size: 25px;
  }
  .sb-service-card h3 {
    font-family: 'Nunito', sans-serif;
    font-size: 19px;
    font-weight: 900;
    color: #1a2e6e;
    margin-bottom: 8px;
  }
  .sb-service-card p {
    color: #66708d;
    font-size: 14px;
    line-height: 1.62;
  }
  .sb-service-list {
    display: grid;
    gap: 8px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(26, 46, 110, 0.08);
  }
  .sb-service-list span {
    color: #39476f;
    font-size: 13px;
    font-weight: 700;
  }
  .sb-service-list span::before {
    content: "+";
    margin-right: 8px;
    color: #F5A623;
    font-weight: 900;
  }

  /* Testimonials */
  .sb-testimonials {
    background: #fff;
  }
  .sb-testi-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }
  .sb-testi-card {
    background: #fff;
    border: 1px solid rgba(26, 46, 110, 0.09);
    border-radius: 8px;
    overflow: hidden;
    text-align: left;
    box-shadow: 0 10px 26px rgba(29, 41, 81, 0.06);
  }
  .sb-testi-img {
    width: 100%;
    height: 198px;
    object-fit: cover;
    object-position: top;
    display: block;
  }
  .sb-testi-body { padding: 22px; }
  .sb-stars {
    width: fit-content;
    color: #8b6418;
    background: rgba(245, 166, 35, 0.1);
    border-radius: 999px;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: 800;
    margin-bottom: 12px;
  }
  .sb-testi-body p {
    color: #4b5572;
    font-size: 14px;
    line-height: 1.66;
    margin-bottom: 16px;
  }
  .sb-testi-name {
    display: block;
    font-family: 'Nunito', sans-serif;
    font-weight: 900;
    color: #1a2e6e;
    font-size: 15px;
    margin-bottom: 3px;
  }
  .sb-testi-university {
    display: block;
    color: #7a849d;
    font-size: 13px;
    font-weight: 700;
  }

  /* Booking Form */
  .sb-booking {
    background: #fbf8ef;
  }
  .sb-booking-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    gap: 22px;
    align-items: start;
  }
  .sb-form-panel,
  .sb-chat-box {
    border: 1px solid rgba(26, 46, 110, 0.1);
    border-radius: 8px;
    background: rgba(255,255,255,0.82);
    box-shadow: 0 14px 32px rgba(29, 41, 81, 0.06);
  }
  .sb-form-panel {
    padding: 26px;
  }
  .sb-form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .sb-form { display: flex; flex-direction: column; gap: 14px; }
  .sb-form-row-wide { grid-column: 1 / -1; }
  .sb-form-row { display: flex; flex-direction: column; gap: 5px; }
  .sb-form-row label {
    font-size: 13px;
    font-weight: 700;
    color: #304180;
  }
  .sb-form-row input,
  .sb-form-row textarea,
  .sb-form-row select {
    width: 100%;
    padding: 13px 14px;
    border: 1.5px solid rgba(26, 46, 110, 0.12);
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Open Sans', sans-serif;
    color: #333;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    background: #fff;
  }
  .sb-form-row input:focus,
  .sb-form-row textarea:focus,
  .sb-form-row select:focus {
    border-color: #1a2e6e;
    box-shadow: 0 0 0 4px rgba(26, 46, 110, 0.08);
  }
  .sb-form-row textarea { resize: vertical; min-height: 112px; }
  .sb-form-submit {
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
  }
  .btn-send {
    background: #1a2e6e;
    color: #fff;
    border: none;
    padding: 13px 30px;
    border-radius: 8px;
    font-weight: 900;
    font-size: 15px;
    cursor: pointer;
    font-family: 'Nunito', sans-serif;
    box-shadow: 0 12px 24px rgba(26, 46, 110, 0.14);
    transition: transform 0.2s, box-shadow 0.2s;
  }
  .btn-send:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 30px rgba(26, 46, 110, 0.2);
  }

  .sb-chat-box {
    padding: 26px;
    height: fit-content;
  }
  .sb-chat-box h3 {
    font-family: 'Nunito', sans-serif;
    font-size: 22px;
    font-weight: 900;
    color: #1a2e6e;
    margin-bottom: 8px;
  }
  .sb-chat-box p {
    color: #66708d;
    font-size: 14px;
    line-height: 1.62;
    margin-bottom: 20px;
  }
  .sb-chat-btns { display: flex; flex-direction: column; gap: 12px; }
  .btn-wa-chat {
    background: #25D366;
    color: #fff;
    border: none;
    padding: 13px;
    border-radius: 8px;
    font-weight: 900;
    font-size: 15px;
    cursor: pointer;
    font-family: 'Nunito', sans-serif;
    width: 100%;
    transition: transform 0.2s, opacity 0.2s;
  }
  .btn-wa-chat:hover { opacity: 0.9; transform: translateY(-2px); }
  .btn-call-us {
    background: #1a2e6e;
    color: #fff;
    border: none;
    padding: 13px;
    border-radius: 8px;
    font-weight: 900;
    font-size: 15px;
    cursor: pointer;
    font-family: 'Nunito', sans-serif;
    width: 100%;
    transition: transform 0.2s, opacity 0.2s;
  }
  .btn-call-us:hover { opacity: 0.9; transform: translateY(-2px); }
  .sb-contact-list {
    display: grid;
    gap: 10px;
    margin: 20px 0;
    padding: 18px 0;
    border-top: 1px solid rgba(26, 46, 110, 0.08);
    border-bottom: 1px solid rgba(26, 46, 110, 0.08);
  }
  .sb-contact-list span {
    color: #3f4d72;
    font-size: 14px;
    font-weight: 700;
  }
  .sb-contact-list span::before {
    content: "-";
    margin-right: 9px;
    color: #F5A623;
  }

  /* Footer */
  .sb-footer {
    background: #1a2e6e;
    padding: 24px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }
  .sb-footer p { color: rgba(255,255,255,0.78); font-size: 14px; line-height: 1.5; }
  .sb-footer-logo {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .sb-footer-logo-icon {
    width: 38px;
    height: 38px;
    background: #F5A623;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
  .sb-footer-logo-text {
    font-family: 'Nunito', sans-serif;
    font-weight: 800;
    font-size: 16px;
    color: #fff;
  }

  /* Responsive */
  @media (max-width: 900px) {
    .sb-section { padding: 64px 24px; }
    .sb-section-head {
      display: block;
    }
    .sb-section-action {
      margin-top: 20px;
    }
    .sb-cards-grid { grid-template-columns: repeat(2, 1fr); }
    .sb-dest-grid { grid-template-columns: repeat(2, 1fr); }
    .sb-services-grid { grid-template-columns: repeat(2, 1fr); }
    .sb-testi-grid { grid-template-columns: 1fr; }
    .sb-booking-layout { grid-template-columns: 1fr; }
    .sb-proof-strip { grid-template-columns: 1fr; }
  }
  @media (max-width: 620px) {
    .sb-nav { padding: 12px 16px; }
    .sb-section { padding: 52px 16px; }
    .sb-section-head,
    .sb-section-head-center {
      margin-bottom: 28px;
    }
    .sb-section-title {
      font-size: 28px;
    }
    .sb-cards-grid { grid-template-columns: 1fr; }
    .sb-dest-grid { grid-template-columns: 1fr; }
    .sb-services-grid { grid-template-columns: 1fr; }
    .sb-form-panel,
    .sb-chat-box {
      padding: 22px;
    }
    .sb-form-grid {
      grid-template-columns: 1fr;
    }
    .sb-booking-layout { grid-template-columns: 1fr; }
    .sb-footer { flex-direction: column; gap: 14px; text-align: center; }
  }
`

const destinations = [
  {
    name: 'Malaysia',
    slug: 'malaysia',
    img: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=400&h=240&fit=crop',
    note: 'Affordable universities with practical English-taught programs.',
    tag: 'Popular pathway',
  },
  {
    name: 'China',
    slug: 'china',
    img: 'https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=400&h=240&fit=crop',
    note: 'Strong scholarship options across medicine, engineering, and business.',
    tag: 'Scholarships',
  },
  {
    name: 'Europe',
    slug: 'europe',
    img: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=400&h=240&fit=crop',
    note: 'Multiple country options with globally respected qualifications.',
    tag: 'Wide choice',
  },
  {
    name: 'Japan',
    slug: 'japan',
    img: 'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=400&h=240&fit=crop',
    note: 'Technology-focused education with a structured student experience.',
    tag: 'Future-ready',
  },
  {
    name: 'South Korea',
    slug: 'south-korea',
    img: 'https://images.unsplash.com/photo-1517154421773-0529f29ea451?w=400&h=240&fit=crop',
    note: 'Modern campuses, strong culture, and growing international programs.',
    tag: 'High demand',
  },
  {
    name: 'Australia',
    slug: 'australia',
    img: 'https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=400&h=240&fit=crop',
    note: 'Career-focused degrees with excellent student support systems.',
    tag: 'Career focused',
  },
  {
    name: 'United Kingdom',
    slug: 'united-kingdom',
    img: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=400&h=240&fit=crop',
    note: 'World-class institutions and efficient degree pathways.',
    tag: 'Top ranked',
  },
]

const whyCards = [
  { icon: '👁️', title: 'Transparent Advice', desc: 'Clear eligibility checks, fee guidance, and next steps before you commit.' },
  { icon: '🧭', title: 'Structured Guidance', desc: 'A practical roadmap from profile review to university and visa milestones.' },
  { icon: '🤝', title: 'Buddy-Level Support', desc: 'Friendly counseling that keeps parents and students informed at every stage.' },
  { icon: '🛟', title: 'Continued Care', desc: 'Responsive WhatsApp and phone support before application, visa, and departure.' },
]

const services = [
  {
    icon: '🏛️',
    title: 'University Admission',
    desc: 'We help shortlist realistic universities, prepare applications, and keep deadlines under control.',
    points: ['Profile review', 'Course matching', 'Application follow-up'],
  },
  {
    icon: '✈️',
    title: 'Visa Support',
    desc: 'From document readiness to interview preparation, we help you present a complete student visa file.',
    points: ['Document checklist', 'Statement review', 'Interview prep'],
  },
  {
    icon: '🧳',
    title: 'Pre-departure Planning',
    desc: 'Practical support for travel, accommodation, budgeting, and first-week preparation abroad.',
    points: ['Travel checklist', 'Housing guidance', 'Arrival briefing'],
  },
]

const testimonials = [
  {
    img: '/testimonials/anwar-hossain-sumon.png',
    quote:
      'I was so lost after my bad result in HSC. I thought I had no other options left, then StudyBuddy came as my guide. They counseled me and helped me from beginning to end in my Study Abroad Journey to Malaysia. I love how they treat me as buddy.',
    name: 'Anwar Hossain Sumon',
    university: 'UNITAR, Malaysia',
  },
  {
    img: '/testimonials/zaber-hossain.png',
    quote:
      'After getting rejected from USA, I got admitted into a private university in Bangladesh. But I always dreamt of studying abroad. After getting in touch with StudyBuddy, they found out what would be best for me and helped me like a very close one, like a buddy to fulfill my study abroad dream. Kudos to the StudyBuddy team.',
    name: 'Zaber Hossain',
    university: 'La Trobe University, Australia',
  },
  {
    img: '/testimonials/maher-kamal.png',
    quote:
      'From my early childhood, I wanted to study abroad. But my financial profile was not up to mark for that. Then StudyBuddy suggested me Malaysia, but I was not confident about Malaysia. Yet they showed me every way which it can turn to be a career changing opportunity. I grabbed it and I am happy that I trusted them.',
    name: 'Maher Kamal',
    university: 'UTM, Malaysia',
  },
]
const CONTACT = {
  whatsapp: 'https://wa.me/8801805758888',
  phone: 'tel:+8801805758888',
  display: '+880 1805-758888',
  facebook: 'https://facebook.com/studybuddy.bd',
  instagram: 'https://instagram.com/mystudybuddybd/?hl=en',
  tiktok: 'https://www.tiktok.com/@studybuddy261',
}
const DESTINATIONS_SECTION_ID = 'study-destinations'
const RETURN_SECTION_KEY = 'studybuddy:return-section'

export default function StudyBuddy() {
  const navigate = useNavigate()

  const [form, setForm] = useState({ name: '', email: '', phone: '', destination: '', questions: '' })

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value })
  const scrollToBooking = () => document.getElementById('book-counseling')?.scrollIntoView({ behavior: 'smooth' })
  const handleDestinationClick = (slug) => {
    window.sessionStorage.setItem(RETURN_SECTION_KEY, DESTINATIONS_SECTION_ID)
    navigate(`/destinations/${slug}`)
  }

  return (
    <>
      <style>{styles}</style>

      {/* Navbar */}
      <nav className="sb-nav">
        <div className="sb-nav-inner">
          <div className="sb-logo">
            <img src="/StudyBuddy-Logo-Transparent.png" alt="StudyBuddy" className="sb-logo-img" />
            <div className="sb-logo-copy">
              <span className="sb-logo-subtitle">Your Buddy for Global Study Journeys</span>
            </div>
          </div>
          <div className="sb-nav-meta">
            <div className="sb-nav-contact">
              <span>WhatsApp / Call</span>
              <strong>{CONTACT.display}</strong>
            </div>
            <div className="sb-nav-btns">
              <button className="btn-whatsapp" onClick={() => window.open(CONTACT.whatsapp, '_blank')}>
                💬<span className="btn-label"> WhatsApp</span>
              </button>

              <button className="btn-call" onClick={() => (window.location.href = CONTACT.phone)}>
                📞<span className="btn-label"> Call us</span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="sb-hero">
        <div className="sb-hero-bg" />
        <div className="sb-hero-float sb-hero-float-left">
          <strong>Admissions Support</strong>
          <span>Personalized guidance from Bangladesh</span>
        </div>
        <div className="sb-hero-float sb-hero-float-right">
          <strong>Visa & Pre-Departure</strong>
          <span>Structured support until you fly</span>
        </div>
        <div className="sb-hero-shell">
          <div className="sb-hero-logo-wrap">
            <img src="/StudyBuddy-Logo-Transparent.png" alt="StudyBuddy" className="sb-hero-logo" />
          </div>
          <p className="sb-hero-kicker">Your Buddy for</p>
          <h1 className="sb-hero-title">
            Global Study
            <span>Journeys</span>
          </h1>
          <p className="sb-hero-copy">
            Professional, transparent support for university admissions, visa preparation, and pre-departure planning so your study abroad journey starts with confidence.
          </p>
          <div className="sb-hero-actions">
            <button className="btn-orange" type="button" onClick={scrollToBooking}>
              Book Free Counseling
            </button>
            <button className="sb-btn-secondary" type="button" onClick={() => window.open(CONTACT.whatsapp, '_blank')}>
              Chat on WhatsApp
            </button>
          </div>
          <div className="sb-hero-points">
            <span className="sb-hero-point">University Admission</span>
            <span className="sb-hero-point">Visa Guidance</span>
            <span className="sb-hero-point">Pre-Departure Support</span>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="sb-section sb-why">
        <div className="sb-section-inner">
          <div className="sb-section-head">
            <div>
              <span className="sb-section-eyebrow">Why choose StudyBuddy</span>
              <h2 className="sb-section-title">Professional guidance with a human touch.</h2>
              <p className="sb-section-lead">
                Study abroad decisions are personal. We combine honest counseling, organized application support, and responsive communication so students and families can move
                forward with clarity.
              </p>
            </div>
            <button className="sb-btn-secondary sb-section-action" type="button" onClick={scrollToBooking}>
              Talk to a counselor
            </button>
          </div>
          <div className="sb-cards-grid">
            {whyCards.map((c) => (
              <div className="sb-card" key={c.title}>
                <div className="sb-card-icon">{c.icon}</div>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
          <div className="sb-proof-strip">
            <div className="sb-proof-item">
              <strong>7</strong>
              <span>destination pathways supported</span>
            </div>
            <div className="sb-proof-item">
              <strong>1:1</strong>
              <span>counseling for every student profile</span>
            </div>
            <div className="sb-proof-item">
              <strong>End-to-end</strong>
              <span>support from admission to departure</span>
            </div>
          </div>
        </div>
      </section>

      {/* Destinations */}
      <section className="sb-section sb-destinations" id={DESTINATIONS_SECTION_ID}>
        <div className="sb-section-inner">
          <div className="sb-section-head">
            <div>
              <span className="sb-section-eyebrow">Study destinations</span>
              <h2 className="sb-section-title">Choose a pathway that fits your goals.</h2>
              <p className="sb-section-lead">Explore countries by cost, academic fit, admission timeline, and long-term opportunity before you begin an application.</p>
            </div>
          </div>
          <div className="sb-dest-grid">
            {destinations.map((d) => (
              <button className="sb-dest-item" key={d.name} type="button" onClick={() => handleDestinationClick(d.slug)}>
                <img className="sb-dest-img" src={d.img} alt={d.name} />
                <div className="sb-dest-body">
                  <h3>{d.name}</h3>
                  <p>{d.note}</p>
                  <div className="sb-dest-meta">
                    <span>{d.tag}</span>
                    <span className="sb-dest-arrow">&gt;</span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="sb-section sb-services">
        <div className="sb-section-inner">
          <div className="sb-section-head-center">
            <span className="sb-section-eyebrow">How we help</span>
            <h2 className="sb-section-title">A calm process for a high-stakes journey.</h2>
            <p className="sb-section-lead">We keep each stage organized, realistic, and easy to follow so you always know what needs to happen next.</p>
          </div>
          <div className="sb-services-grid">
            {services.map((s, index) => (
              <div className="sb-service-card" key={s.title}>
                <span className="sb-service-step">0{index + 1}</span>
                <div className="sb-service-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <div className="sb-service-list">
                  {s.points.map((point) => (
                    <span key={point}>{point}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="sb-section sb-testimonials">
        <div className="sb-section-inner">
          <div className="sb-section-head-center">
            <span className="sb-section-eyebrow">Student stories</span>
            <h2 className="sb-section-title">Real journeys, steady support.</h2>
            <p className="sb-section-lead">Students come to us with different academic records, budgets, and dreams. The goal is always the same: a clear, confident next step.</p>
          </div>
          <div className="sb-testi-grid">
            {testimonials.map((t) => (
              <div className="sb-testi-card" key={t.name}>
                <img className="sb-testi-img" src={t.img} alt={t.name} />
                <div className="sb-testi-body">
                  <div className="sb-stars">5/5 rating</div>
                  <p>"{t.quote}"</p>
                  <span className="sb-testi-name">{t.name}</span>
                  <span className="sb-testi-university">{t.university}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Book Counseling */}
      <section className="sb-section sb-booking" id="book-counseling">
        <div className="sb-section-inner">
          <div className="sb-section-head-center">
            <span className="sb-section-eyebrow">Free counseling</span>
            <h2 className="sb-section-title">Start with one clear conversation.</h2>
            <p className="sb-section-lead">
              Tell us where you are in the process. We will help you understand destination fit, admission options, and the documents you should prepare first.
            </p>
          </div>
          <div className="sb-booking-layout">
            <div className="sb-form-panel">
              <div className="sb-form">
                <div className="sb-form-grid">
                  <div className="sb-form-row">
                    <label>Full name *</label>
                    <input name="name" value={form.name} onChange={handleChange} placeholder="Your full name" />
                  </div>
                  <div className="sb-form-row">
                    <label>Email *</label>
                    <input name="email" value={form.email} onChange={handleChange} placeholder="your@email.com" type="email" />
                  </div>
                  <div className="sb-form-row">
                    <label>WhatsApp/Phone *</label>
                    <input name="phone" value={form.phone} onChange={handleChange} placeholder={CONTACT.display} />
                  </div>
                  <div className="sb-form-row">
                    <label>Destination of interest</label>
                    <select name="destination" value={form.destination} onChange={handleChange}>
                      <option value="">Select a destination</option>
                      {destinations.map((d) => (
                        <option key={d.name}>{d.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="sb-form-row sb-form-row-wide">
                    <label>Your questions *</label>
                    <textarea name="questions" value={form.questions} onChange={handleChange} placeholder="What would you like to know?" />
                  </div>
                </div>
                <div className="sb-form-submit">
                  <button className="btn-send" type="button">
                    Send request
                  </button>
                </div>
              </div>
            </div>
            <div className="sb-chat-box">
              <h3>Prefer chat?</h3>
              <p>Reach the StudyBuddy team directly at {CONTACT.display}. We can quickly confirm eligibility, document gaps, and next steps.</p>
              <div className="sb-contact-list">
                <span>Fast response on WhatsApp</span>
                <span>Student and parent-friendly guidance</span>
                <span>Bangladesh-based counseling team</span>
              </div>
              <div className="sb-chat-btns">
                <button className="btn-wa-chat" onClick={() => window.open(CONTACT.whatsapp, '_blank')}>
                  💬 Chat on WhatsApp
                </button>

                <button className="btn-call-us" onClick={() => (window.location.href = CONTACT.phone)}>
                  📞 Call us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="sb-footer">
        <p>© 2026 StudyBuddy. All rights reserved. WhatsApp/Call: {CONTACT.display}</p>

        <div className="sb-footer-right">
          <div className="sb-footer-socials">
            <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer">
              Facebook
            </a>

            <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer">
              Instagram
            </a>

            <a href={CONTACT.tiktok} target="_blank" rel="noopener noreferrer">
              Tiktok
            </a>
          </div>

          <img src="/StudyBuddy-Logo-Transparent.png" alt="StudyBuddy" className="sb-footer-logo-img" />
        </div>
      </footer>
    </>
  )
}
